module.exports = __webpack_public_path__ + "d6ec3c64891a2c3db8db1862901361c2.png";